import { api } from '@/api/client'
import type { ItemMapping } from '@/types/models'
import { ListPickerModal } from './ListPickerModal'

interface Props {
  /** 검색 대상 상위 거래처. null 이면 비활성(먼저 상위 거래처 선택 필요). */
  groupId: number | null
  value: number | null
  onChange: (m: ItemMapping) => void
  placeholder?: string
}

/** 기존 견적서 매핑(kind=quote)을 코드/품명으로 검색해 고르는 피커.
 *
 *  발주서 코드매칭에서 "견적서 코드" 를 고르는 용도. 선택하면 그 견적 매핑의
 *  견적코드(source_code) · 견적품명(source_name) · 연결 품목(item) 이 확정된다.
 *  그룹 스코프이므로 groupId 를 함께 넘긴다.
 */
export function QuoteMappingPicker({
  groupId, value, onChange, placeholder = '견적서 코드/품명 검색...',
}: Props) {
  return (
    <ListPickerModal<ItemMapping>
      value={value}
      onChange={onChange}
      title="견적서 매핑 선택"
      triggerPlaceholder={groupId ? placeholder : '상위 거래처를 먼저 선택하세요'}
      searchPlaceholder="견적코드 · 견적품명 · 품목"
      emptyText={groupId ? '검색 결과 없음' : '상위 거래처를 먼저 선택하세요'}
      queryKey={['quote-mapping-picker', groupId]}
      fetchDetail={(id) => api<ItemMapping>(`/api/item-mappings/${id}`)}
      fetchList={(q) => {
        if (!groupId) return Promise.resolve([])
        const params = new URLSearchParams()
        params.set('kind', 'quote')
        params.set('group_id', String(groupId))
        if (q) params.set('q', q)
        return api<ItemMapping[]>(`/api/item-mappings?${params}`)
      }}
      formatLabel={(m) => `${m.source_code} ${m.source_name} → ${m.item_name}`}
      renderRow={(m) => (
        <>
          <span className="font-mono text-xs text-slate-500 tabular-nums mr-2">{m.source_code}</span>
          <span>{m.source_name}</span>
          <span className="text-xs text-slate-400 ml-2">→ {m.item_code} {m.item_name}</span>
        </>
      )}
    />
  )
}
